import React from 'react';
import Contacts from '../defaults/Contacts';

export default (props) => {
  return (
    <Contacts />
  );
}
